import React from 'react';
import PropTypes from 'prop-types';
import cx from 'clsx';
import s from './gridRow.module.scss';

const GridRow = ({ children, justifyRow, alignRow, noWrap, column, className, gutter }) => {
    const style = cx(
        s.item,
        justifyRow && s[`justify-${justifyRow}`],
        alignRow && s[`align-${alignRow}`],
        noWrap && s.noWrap,
        column && s.column,
        gutter && s[`gutter-${gutter}`],
        className,
    );

    return <div className={style}>{children}</div>;
};

GridRow.propTypes = {
    noWrap: PropTypes.bool,
    column: PropTypes.bool,
    justifyRow: PropTypes.oneOf(['left', 'right', 'center', 'around', 'between']),
    alignRow: PropTypes.oneOf(['middle', 'top', 'bottom', 'stretch']),
    className: PropTypes.string,
    gutter: PropTypes.number,
};

export default GridRow;
